var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifyCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "41px",
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u53D6\u6D88_40dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0419\\u66F4\\u65B0--\\u64CD\\u4F5C\\u63D0\\u793A\\u6C14\\u6CE1",
    transform: "translate(-1076.000000, -288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-4",
    transform: "translate(1058.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u53D6\\u6D88_40dp",
    transform: "translate(18.000000, 20.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L40,0 L40,40 L0,40 L0,0 Z M0,0 L40,0 L40,40 L0,40 L0,0 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.3,
    fill: "#FFFFFF",
    x: 11,
    y: 18,
    width: 18,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,3.33333333 C10.8,3.33333333 3.33333333,10.8 3.33333333,20 C3.33333333,29.2 10.8,36.6666667 20,36.6666667 C29.2,36.6666667 36.6666667,29.2 36.6666667,20 C36.6666667,10.8 29.2,3.33333333 20,3.33333333 Z M20,33.3333333 C12.6333333,33.3333333 6.66666667,27.3666667 6.66666667,20 C6.66666667,12.6333333 12.6333333,6.66666667 20,6.66666667 C27.3666667,6.66666667 33.3333333,12.6333333 33.3333333,20 C33.3333333,27.3666667 27.3666667,33.3333333 20,33.3333333 Z",
    id: "\\u5F62\\u72B6",
    fillOpacity: 0.3,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyCancel);
export default __webpack_public_path__ + "static/media/notify_cancel.71d2bc99e5873658fc2f275e3303437f.svg";
export { ForwardRef as ReactComponent };